<template>
  <div>
    <header-image
      :headerContents="headerContents"
      :headerBackground="'stories'"/>
    <div class="grid-container full page-contents-6"
         style="margin-top: 90px; margin-bottom: 42px; ">
      <div class="grid-x grid-padding-x small-up-1 medium-up-3 large-up-3 align-center">
        <div v-for="story in stories"
          :key="story.storyID"
          class="cell align-center">
          <story-card
            :tabindex="story.tabIndex"
            :storyID="story.storyID"
            :storyName="story.storyName"
            :storyPosition="story.storyPosition"
            @openStoriesModal="openStoriesModal"
          />
        </div>
      </div>
    </div>

    <want-to-know-more/>
    <rare-awards/>
    <rare-stories-modal
      v-if="storiesModalOpen"
      :storyIDtoOpen="storyIDtoOpen"
      @closeStoriesModal="closeStoriesModal"
    />

  </div>
</template>

<script>

import HeaderHeroImage from '../../components/header/HeaderHeroImage';
import RareWantToKnowMore from '../../components/commonSections/RareWantToKnowMore';

import RareStoriesHeaderContents from './components/RareStoriesHeaderContents';
import RareStoriesStoryCard from './components/RareStoriesStoryCard';

import StoriesModal from './components/RareStoriesStoryModal';
import RareAwards from '../../components/carousels/awardsCarousel';


export default {
  name: 'stories',
  components: {
    'header-image': HeaderHeroImage,
    'want-to-know-more': RareWantToKnowMore,
    'rare-stories-header-contents': RareStoriesHeaderContents,
    'story-card': RareStoriesStoryCard,
    'rare-stories-modal': StoriesModal,
    'rare-awards': RareAwards,
  },
  data() {
    return {
      headerContents: 'rare-stories-header-contents',
      storiesModalOpen: false,
      storyIDtoOpen: 'xxx',
      oldYPos: 0,
      stories: [
        {
          storyID: 'Ailsa',
          storyName: 'Ailsa Harris',
          storyPosition: 'Department for Education',
          tabIndex: 20,
        },
        {
          storyID: 'Sengova',
          storyName: 'Sengova Kailondo',
          storyPosition: 'Hogan Lovells',
          tabIndex: 21,
        },
        {
          storyID: 'Roy',
          storyName: 'Roy Appiah',
          storyPosition: 'Clifford Chance ',
          tabIndex: 22,
        },
        {
          storyID: 'Tony',
          storyName: 'Tony Upton',
          storyPosition: 'Clyde & Co',
          tabIndex: 25,
        },
        {
          storyID: 'David',
          storyName: 'David Odejayi',
          storyPosition: 'A & O Shearman',
          tabIndex: 26,
        },
        {
          storyID: 'Hamze',
          storyName: 'Hamze Ali',
          storyPosition: 'Bain & Company',
          tabIndex: 27,
        },
      ],
    };
  },
  methods: {
    closeStoriesModal() {
      window.scrollTo(0, this.oldYPos);
      this.storiesModalOpen = false;
      this.$emit('closeStoriesModal');
    },
    openStoriesModal(storyID) {
      this.oldYPos = window.scrollY;
      window.scrollTo(0, 0);
      this.storiesModalOpen = true;
      this.storyIDtoOpen = storyID;
      this.$emit('openStoriesModal');
    },
  },
  watch: {
    $route() {
      this.closeStoriesModal();
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

</style>



// WEBPACK FOOTER //
// src/pages/stories/stories.vue